/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export default function Images({
    type = 'image/webp',
  src = '',
  alt = '',
  className = '',
  imageClassName = '',
  width = 0,
  height = 0,
  auth = false,
}) {
  const { accessToken } = useSelector((state) => state.adminReducers);
  const [imageSrc, setImageSrc] = useState(null);
  const [zoomedImage, setZoomedImage] = useState(null);

  useEffect(() => {
    fetchData()
  }, [src]);

  const fetchData = async () => {
    try {
      const response = await fetchImageWithAuthorization(`${process.env.REACT_APP_BASE_URL}file/view/file/${src}`);
      if (response?.status === 200) {
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        setImageSrc(url);
      }
    } catch (error) {
      console.log('Error fetching data:', error);
    }
  };

  const fetchImageWithAuthorization = async (url) => {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${accessToken}`);
    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow'
    };
    return fetch(url, requestOptions);
  };

  const handleImageClick = () => {
    setZoomedImage(imageSrc);
  };

  const handleOverlayClick = () => {
    setZoomedImage(null);
  };
  
  return (
    <picture style={{ position: "relative" }} className={`picture-opacity-1 ${imageClassName}`}>
      {imageSrc && <source type={type} srcSet={imageSrc} />}
      {imageSrc && (
        <img
          src={imageSrc}
          alt={alt}
          loading="eager"
          className={className}
          width={width}
          height={height}
          onClick={alt === 'Document' ? handleImageClick : null}
          style={{ cursor: alt === 'Document' ? 'zoom-in' : 'default' }}
          />
      )}
      {zoomedImage && (
          <div className="zoom-overlay" onClick={handleOverlayClick}>
            <img src={zoomedImage} alt="Zoomed Document" />
          </div>
        )}
    </picture>
  );
}

Images.propTypes = {
  type: PropTypes.any,
  src: PropTypes.any,
  alt: PropTypes.any,
  className: PropTypes.any,
  imageClassName: PropTypes.any,
  width: PropTypes.any,
  height: PropTypes.any,
  auth: PropTypes.bool,
};

// Images.defaultProps = {
//   type: 'image/webp',
//   src: '',
//   alt: '',
//   className: '',
//   imageClassName: '',
//   width: 0,
//   height: 0,
//   auth: false,
// };